import React, { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import NationalBank from "./NationalBank";
import StateBanks from "./StateBanks";
import OutOfState from "./OutOfState";
import StateIndustrial from "./StateIndustrial";
import FedralCredit from "./FedralCredit";
import FedralSavings from "./FedralSavings";
import StateCredit from "./StateCredit";
import TrustCompany from "./TrustCompany";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "../styles/finance.css";

const dfi = "/img/dfi.png";

const Finance = () => {
  const data = [
    { label: "National Banks", component: <NationalBank /> },
    { label: "State Banks", component: <StateBanks /> },
    { label: "Out-of-State State Banks", component: <OutOfState /> },
    { label: "State Industrial Banks", component: <StateIndustrial /> },
    { label: "Federal Credit Unions", component: <FedralCredit /> },
    { label: "Federal Saving Associations", component: <FedralSavings /> },
    { label: "State Credit Unions", component: <StateCredit /> },
    { label: "Trust Company", component: <TrustCompany /> },
  ];

  const [activeTab, setActiveTab] = useState("National Banks");

  return (
    <>
      <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
        <LandingSection
          data={{
            imageName: "finance3.webp",
            title: "Utah's Financial Institutions",
            visible: "",
          }}
        />

        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>Financial Institutions</h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Review personal finance trends, average incomes, economic
                stability, and financial health.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Tabs
        id="finance-tabs-row1"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {data.slice(0, 5).map((item, index) => (
          <Tab key={index} eventKey={item.label} title={item.label} />
        ))}
      </Tabs>

      <Tabs
        id="finance-tabs-row2"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        variant="pills"
        className="mb-3 flex flex-wrap justify-center gap-2 custom-tabs"
      >
        {data.slice(5).map((item, index) => (
          <Tab key={index + 5} eventKey={item.label} title={item.label} />
        ))}
      </Tabs>

      {/* Tab content (table) */}
      <div className="mt-4">
        {data.find((d) => d.label === activeTab)?.component}
      </div>

      {/* Data Sources */}
      <div className="mt-8 mb-8 border-t border-gray-300 pt-6 text-center text-sm text-gray-700 max-w-3xl mx-auto px-4">
        <p className="font-semibold mb-3">Data Sources:</p>
        <div className="flex flex-col items-center gap-2">
          <a
            target="_blank"
            href="https://www.utah.gov/dfi/FinancialInstitutions.html"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Utah Government - Financial Institutions
          </a>
          <a
            target="_blank"
            href="https://business.utah.gov/targeted-industries/finance/"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Utah Business - Finance Industry
          </a>
          <a
            target="_blank"
            href="https://wallethub.com/insurance-companies#loc=Utah"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            WalletHub - Insurance Companies
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Finance;
